import React , { Component } from 'react';
import { Link } from 'react-router-dom';
import Translation from '../../Translation';
export default class PageNotFound extends Component {
    render() {
        return (
            <div className="error-wrapper">
                <div className="error-wrapper-content">
                    <img alt='error' src="./images/404.svg" className="error-img forbidden-img" />
                    <h1 className="error-wrapper-title"> <Translation labelName="lbl_page_not_found" defaultText="PAGE NOT FOUND" /> </h1>
                    <button type="button" className="btn btn-primary">
                        <Link to='/'><Translation labelName="lbl_back_to_home" defaultText="BACK TO HOME" /></Link>
                    </button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Error/index.js